// Favorite script
const BRIDGE_BASE_URL_FAV = '/apps/apibridge/integration/path/';
const customerId = window.KROWN.settings.favSet.cid
const pageType = window.KROWN.settings.favSet.pageType
const isProductPage = pageType === 'product'
let favoritedVariantIDinDb = null
const FAV_SAVE_URL = BRIDGE_BASE_URL_FAV + 'cm4rm8csb007m12ut0hww3fcn'
const FAV_GET_URL = BRIDGE_BASE_URL_FAV + 'cm4rm1min007912utgkn1v57t'
const pdpOriginalPriceSelector = '[data-js-product-price-original]'
const pdpCurrentVariantSelector = '[data-current-value]'
const karacaCorparateNumber = 1

/*
GET
{
    "customer": 7120971071708,
    "corporateCountry": 1
}
SAVE
{
    "favoriteProduct": {
        "ProductTargetUniqueId": "8251703787740",
        "ProductVariantTargetUniqueId": "44348984066268",
        "CustomerTargetUniqueId": 7120971071708,
        "OldPrice": 2000.00,
        "corporateCountry": 1
    }
}
*/
function isLoggedIn(){
  if(customerId) return true
  else return false
}

async function setUserFavorite (data,svgIcon,productData) {
  svgIcon.parentNode.classList.add('svg-loading')
  delete data.favoriteProduct.Data;
  try{
    const res = await fetch(FAV_SAVE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const fetchResponse = await res.json();
    const response = JSON.parse(fetchResponse.data.body)

    if (response.data && Object.keys(response.data).length > 0) {
      const collections = productData.collections ? productData.collections.split(', ') : ['No Collections'];
    
      const dataLayerPush = {
        event: 'add_to_wishlist',
        ecommerce: {
          wishlist_id: "", 
          wishlist_type: "Favorites",
          action_area: "PDP",
          items: [{
            item_name: productData.title,
            item_originalPrice: response.data.favoriteProduct.oldPrice,
            item_id: response.data.favoriteProduct.productTargetUniqueId.toString(),
            item_mpn: response.data.favoriteProduct.productTargetUniqueId.toString(),
            price: response.data.favoriteProduct.oldPrice,
            quantity: "1",
            item_barcode: response.data.favoriteProduct.productTargetUniqueId, 
            item_brand: "",
            item_category: collections[0] || "",
            item_category2: collections[1] || "",
            item_category3: collections[2] || "",
            item_category4: collections[3] || "",
            item_category5: collections[4] || "",
            item_variant: response.data.favoriteProduct.productVariantTargetUniqueId.toString(), 
          }]
        }
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerPush);
    }
  } catch(e) {
    console.warn("setUserFavorite ",e)
  }finally{
    svgIcon.parentNode.classList.remove('svg-loading')
  }
}
function handleLocalStorage(key,data){
  if(customerId) return
  const favorites = localStorage.getItem(key)
  if(favorites){
    const favoritesArray = JSON.parse(favorites);

    const dataKey = data.favoriteProduct.ProductTargetUniqueId
    let hasData = false
    for (let i=0; i < favoritesArray.length; i++) {
      if (favoritesArray[i].favoriteProduct.ProductTargetUniqueId == dataKey) {
          favoritesArray.splice(i, 1);
          hasData = true
      }
    }
    if(!hasData) {
      favoritesArray.push(data)
    }
    localStorage.setItem(key, JSON.stringify(favoritesArray));
  } else {
    const localData = [data]
    localStorage.setItem(key,JSON.stringify(localData))
  }
}
function handleSessionStorage(key,data){
  if(!customerId) return

  const favorites = sessionStorage.getItem(key)
  if(favorites){
    const favoritesArray = JSON.parse(favorites);

    const dataKey = data.favoriteProduct.ProductTargetUniqueId
    let hasData = false
    for (let i=0; i < favoritesArray.length; i++) {
      const dataId = favoritesArray[i].productTargetUniqueId || favoritesArray[i].ProductTargetUniqueId
      if (dataId == dataKey) {
        favoritesArray.splice(i, 1);
        hasData = true
      }
    }
    if(!hasData) {
      favoritesArray.push(data.favoriteProduct)
    }
    sessionStorage.setItem(key, JSON.stringify(favoritesArray));
  } else {
    sessionStorage.setItem(key, JSON.stringify([data.favoriteProduct]));
  }
}
function handleClickFavorite(e) {
    e.preventDefault()
    const isLogin = isLoggedIn()
    if(!isLogin) {
      window.location.assign('/account/login?return_url=%2Faccount%3Fstate%3Dmy-favorites')
      return
    }
    if(pageType === 'cart'){
        if(e.target.classList.contains('favorited-item')) return
        e.currentTarget = e.detail.customCurrentTarget
    }
    const productData = {
        title: e.currentTarget.dataset.favtitle,
        handle: e.currentTarget.dataset.favhandle,
        img: e.currentTarget.dataset.favimg,
        price: e.currentTarget.dataset.favprice,
        cprice: e.currentTarget.dataset.favcompareprice,
        vname: e.currentTarget.dataset.favvariantname,
        collections: e.currentTarget.dataset.productcollections
    }
    const data = {
        favoriteProduct:{
            ProductTargetUniqueId : e.currentTarget.dataset.productfavid,
            ProductVariantTargetUniqueId : e.currentTarget.dataset.variantfavid,
            CustomerTargetUniqueId : customerId,
            corporateCountry: karacaCorparateNumber,
            oldPrice: e.currentTarget.dataset.favprice,
            Data: JSON.stringify(productData)
        }
    }
    e.currentTarget.classList.toggle('favorited-item')
    e.currentTarget.classList.toggle('!stroke-kred')
    if(!customerId) {
        handleLocalStorage('favoriteItems',data)
        return
    }

    setUserFavorite(data, e.currentTarget.parentNode, productData);
    handleSessionStorage('favoriteItems',data)
}
function getVariantParams() {
  const params = new URLSearchParams(window.location.search);
  return +params.get('variant') || +document.querySelector('[data-current-variant]').getAttribute('data-current-variant');
}
function handleClickPDPFavorite(e) {
  e.preventDefault()
  const isLogin = isLoggedIn()
  if(!isLogin) {
    window.location.assign('/account/login?return_url=%2Faccount%3Fstate%3Dmy-favorites')
    return
  }
  const isFavorited = favoritedVariantIDinDb === null ? false : true
  const productData = {
      title: e.currentTarget.dataset.favtitle,
      handle: e.currentTarget.dataset.favhandle,
      img: e.currentTarget.dataset.favimg,
      price: e.currentTarget.dataset.favprice,
      cprice: e.currentTarget.dataset.favcompareprice,
      vname: e.currentTarget.dataset.favvariantname,
      collections: e.currentTarget.dataset.productcollections
  }
  const data = {
      favoriteProduct: {
          ProductTargetUniqueId : e.currentTarget.dataset.productfavid,
          ProductVariantTargetUniqueId : e.currentTarget.dataset.variantfavid,
          CustomerTargetUniqueId : customerId,
          oldPrice: e.currentTarget.dataset.favprice,
          corporateCountry: karacaCorparateNumber
      }
  }
  isFavorited
  ? handleDeleteFavorite(data, e.currentTarget)
  : handleAddFavorite(data,productData,e.currentTarget)
  e.currentTarget.classList.toggle('favorited-item')
  e.currentTarget.classList.toggle('!stroke-kred')
}
function handleAddFavorite(data,productData,svgIcon){
  const currentVariant = getVariantParams()
  const currentPrice = Number(document.querySelector(pdpOriginalPriceSelector).innerText.replace(/\D/g, ""))
  let variantStr = ""
  const currentVariantNames = document.querySelectorAll(pdpCurrentVariantSelector)
  currentVariantNames.forEach((item,i) => {
    variantStr += item.innerText;
    i === 0 ? variantStr += ' / ' : null;
  })

  productData.price = currentPrice
  productData.vname = variantStr
  data.favoriteProduct.ProductVariantTargetUniqueId = currentVariant
  data.favoriteProduct.Data = JSON.stringify(productData)

  favoritedVariantIDinDb = currentVariant
  if(!customerId) {
    const favorites = localStorage.getItem('favoriteItems')
    const arr = favorites ? JSON.parse(favorites) : []

    data.favoriteProduct.ProductTargetUniqueId = data.favoriteProduct.ProductTargetUniqueId
    arr.push(data)
    localStorage.setItem('favoriteItems',JSON.stringify(arr))
    return
  }
  // add to sessionStorage
  const sessionFavorites = sessionStorage.getItem('favoriteItems')
  const sessionArr = sessionFavorites ? JSON.parse(sessionFavorites) : []
  sessionArr.push(data.favoriteProduct)
  sessionStorage.setItem('favoriteItems',JSON.stringify(sessionArr))

  setUserFavorite(data,svgIcon,productData)
}
function handleDeleteFavorite(data,svgIcon){
  data.favoriteProduct.ProductVariantTargetUniqueId = favoritedVariantIDinDb
  favoritedVariantIDinDb = null
  if(!customerId) {
    const favorites = localStorage.getItem('favoriteItems')
    let arr = favorites ? JSON.parse(favorites) : []
    arr = arr.filter(item => item.favoriteProduct.ProductTargetUniqueId != data.favoriteProduct.ProductTargetUniqueId)
    localStorage.setItem('favoriteItems',JSON.stringify(arr))
    return
  }
  // delete from session
  const sessionFavorites = sessionStorage.getItem('favoriteItems')
  let sessionArr = sessionFavorites ? JSON.parse(sessionFavorites) : []
  sessionArr = sessionArr.filter(item => {
    const itemId = item.ProductTargetUniqueId || item.productTargetUniqueId
    return itemId != data.favoriteProduct.ProductTargetUniqueId
  })
  sessionStorage.setItem('favoriteItems',JSON.stringify(sessionArr))

  setUserFavorite(data,svgIcon)
}
async function setLocalStorageToDb(response,localfavs) {
  const parsed = JSON.parse(localfavs)
  const dbIdArray = response.map(item => item.productTargetUniqueId)
  
  for(let i=0;i<parsed.length;i++){
    if(!dbIdArray.includes(+parsed[i].favoriteProduct.ProductTargetUniqueId)){
      parsed[i].favoriteProduct.CustomerTargetUniqueId = customerId
      Number(parsed[i].favoriteProduct.productTargetUniqueId)
      Number(parsed[i].favoriteProduct.productVariantTargetUniqueId)
      await fetch(FAV_SAVE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(parsed[i])
      });
    }
  }
  localStorage.removeItem('favoriteItems')
  getUserFavorites()
}
function handleFillFavoriteIcons(data,allFavoriteIcons,isSession = false) {
  if (!data.length) {
    allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'))
    return;
  }

  let userFavoriteMap
  if(!customerId) {
      data = data.map(item => item.favoriteProduct)
    userFavoriteMap = new Map(data.map(item => [+item.ProductTargetUniqueId, +item.ProductVariantTargetUniqueId]));
  } else if(isSession) {
    userFavoriteMap = new Map(data.map(item => {
      if(item['guid']) return [item.productTargetUniqueId, item.productVariantTargetUniqueId]
      return [+item.ProductTargetUniqueId, +item.ProductVariantTargetUniqueId]
    }));
  } else {
    userFavoriteMap = new Map(data.map(item => [item.productTargetUniqueId, item.productVariantTargetUniqueId]));
  }
  requestAnimationFrame(() => {
    allFavoriteIcons.forEach(icon => {
      const id = Number(icon.dataset.productfavid);
      if (userFavoriteMap.has(id)) {
        const variantId = userFavoriteMap.get(id)
        if(isProductPage && icon.hasAttribute('data-productselector')) {
            favoritedVariantIDinDb = variantId;
        }
        icon.classList.add('favorited-item');
        icon.classList.add('!stroke-kred');
        icon.dataset.variantfavid = variantId;
      }
      icon.parentNode.classList.remove('svg-loading')
    });
  });
}
async function getUserFavorites() {
  const allFavoriteIcons = document.querySelectorAll('[data-favorite-item]');
  if(!allFavoriteIcons) return

  const localFavorites = localStorage.getItem('favoriteItems')
  if(!customerId && localFavorites) {
    handleFillFavoriteIcons(JSON.parse(localFavorites),allFavoriteIcons)
    return
  }
  if(!customerId && !localFavorites) return

  const sessionFavorites = sessionStorage.getItem('favoriteItems')
  if(sessionFavorites){
  const parsedSessionFavorites = JSON.parse(sessionFavorites)
    if(parsedSessionFavorites.length) {
      handleFillFavoriteIcons(parsedSessionFavorites,allFavoriteIcons,true)
      return
    }
  }

  try {
    const res = await fetch(FAV_GET_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({customer : customerId,  corporateCountry: karacaCorparateNumber })
    });

    const fetchResponse = await res.json();
    const response = JSON.parse(fetchResponse.data.body);
    
    if(customerId && localFavorites && response){
      setLocalStorageToDb(response.data,localFavorites)
      return
    }
    sessionStorage.setItem('favoriteItems',JSON.stringify(response.data))
    handleFillFavoriteIcons(response.data,allFavoriteIcons)
  } catch(e) {
    console.error("getUserFavorites", e)
  }

}
window.addEventListener("DOMContentLoaded", getUserFavorites)
